export var UserCardType;
(function (UserCardType) {
    UserCardType["User"] = "user";
    UserCardType["Group"] = "group";
    UserCardType["Web"] = "web";
    UserCardType["CustomUser"] = "customUser";
})(UserCardType || (UserCardType = {}));
export var UserCardAction;
(function (UserCardAction) {
    UserCardAction["Chat"] = "chat";
    UserCardAction["AddGroup"] = "addGroup";
    UserCardAction["AppliedGroup"] = "appliedGroup";
    UserCardAction["JoinGroup"] = "JoinGroup";
    UserCardAction["SendApplyGroup"] = "sendApplyGroup";
    UserCardAction["More_Times_Group"] = "more_times_group";
    UserCardAction["Add"] = "add";
    UserCardAction["Send"] = "send";
    UserCardAction["Applied"] = "applied";
    UserCardAction["Done"] = "done";
    UserCardAction["Accept"] = "accept";
    UserCardAction["More_Times"] = "more_times";
    UserCardAction["Voip"] = "voip";
    UserCardAction["Jrtc"] = "jrtc";
    UserCardAction["Meeting"] = "Meeting";
    UserCardAction["XCMeeting"] = "XCMeeting";
    UserCardAction["XYMeeting"] = "XYMeeting";
    UserCardAction["Share"] = "share";
    UserCardAction["No"] = "no";
    UserCardAction["Expired"] = "Expired";
    UserCardAction["Deleted"] = "Deleted";
    UserCardAction["Tag"] = "Tag";
    UserCardAction["Web"] = "web";
    UserCardAction["CustomUser"] = "customUser";
    UserCardAction["UnitAdministrator"] = "UnitAdministrator";
    UserCardAction["Administrator"] = "Administrator";
    UserCardAction["Reply"] = "Reply";
    UserCardAction["Sended"] = "Sended";
})(UserCardAction || (UserCardAction = {}));
export default {};
//# sourceMappingURL=UserCardType.js.map